import React, { useState } from "react";
import { Modal, Box, Button, FormControlLabel, Checkbox } from "@mui/material";
import { fetchAuthSession } from "@aws-amplify/auth";
import config from "../utils/Constants";

const AwsModal = ({ open, onClose, pdfUrl }) => {
  const [selectedResources, setSelectedResources] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const awsResources = ["S3"];

  const handleCheckboxChange = (resource) => {
    setSelectedResources((prev) =>
      prev.includes(resource)
        ? prev.filter((r) => r !== resource)
        : [...prev, resource]
    );
  };

  // Upload PDF to S3 via backend proxy
  const uploadToS3 = async () => {
    if (!pdfUrl) {
      setErrorMessage("No PDF file found for upload.");
      return;
    }

    setLoading(true);
    setErrorMessage("");

    try {
      const apiUrl = config.getDynamicApiUrl();
      const session = await fetchAuthSession();
      const token = session.tokens.accessToken.toString();

      const response = await fetch(`${apiUrl}/api/v1/integrations/aws_s3/upload/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          pdf_url: pdfUrl,
          file_name: `pdf-${Date.now()}.pdf`,
        }),
      });

      const data = await response.json();

      if (data.success) {
        console.log("Upload Success:", data.location);
      } else {
        console.error("S3 Upload Error:", data.error);
        setErrorMessage(data.error || "Upload failed.");
      }
    } catch (error) {
      console.error("S3 Upload Error:", error);
      setErrorMessage(error.message);
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <h3>Select AWS Resources to Send</h3>
        {awsResources.map((resource) => (
          <FormControlLabel
            key={resource}
            control={
              <Checkbox
                checked={selectedResources.includes(resource)}
                onChange={() => handleCheckboxChange(resource)}
              />
            }
            label={resource}
            style={{ display: "block" }}
          />
        ))}

        {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}

        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
          <Button onClick={onClose} color="secondary" disabled={loading}>
            Cancel
          </Button>
          <Button
            onClick={uploadToS3}
            variant="contained"
            color="primary"
            disabled={loading || selectedResources.length === 0}
          >
            {loading ? "Uploading..." : "Upload to S3"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AwsModal;
